"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgDropper = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { d: "M1.89 22.994a.99.99 0 0 1-.594-.29.99.99 0 0 1-.29-.594c-.03-.267.031-.561.088-.835l.04-.2c.091-.49.24-1.167.472-1.929.456-1.498 1.266-3.433 2.687-4.853L10.586 8l-.793-.793a1 1 0 0 1 1.414-1.414l7 7a1 1 0 0 1-1.414 1.414L16 13.414l-6.293 6.293c-1.42 1.42-3.355 2.23-4.853 2.687-.762.232-1.44.38-1.928.472a9.894 9.894 0 0 0-.201.04c-.274.056-.568.117-.835.088ZM14.546 4.04c-.396.396-.594.594-.669.823a1 1 0 0 0 0 .618c.075.228.273.426.669.822l3.151 3.151c.396.396.594.595.822.669a1 1 0 0 0 .619 0c.228-.074.426-.273.822-.669l1.747-1.747a3.828 3.828 0 0 0 0-5.414l-.002-.003a3.828 3.828 0 0 0-5.412.003L14.546 4.04Z", fill: "currentColor" }) }))); };
exports.default = SvgDropper;
